import styled, { css } from 'styled-components';
import { notificationStyle } from './Notification.utils';

export const StyledNotifications = styled.div`
  position: fixed;
  right: 8px;
  bottom: 8px;
  width: 450px;
  z-index: 101;

  > .tools {
    display: flex;
    justify-content: flex-end;
    padding: 0 8px;
  }

  > div {
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

const grayColors = css`
  color: ${props => props.theme.colorGrayDarker};
  background-color: ${props => props.theme.colorGrayLighter};
`;

const successColors = css`
  color: ${props => props.theme.colorGreen};
  background-color: #e2ffeb;
`;

const errorColors = css`
  color: ${props => props.theme.colorRed};
  background-color: #fff4f7;
`;

const colorStyles = {
  [notificationStyle.error]: errorColors,
  [notificationStyle.gray]: grayColors,
  [notificationStyle.success]: successColors
}

export const StyledNotification = styled.div`
  padding: 0 32px 0 16px;
  overflow-y: auto;
  border-radius: 2px;
  box-shadow: 0 2px 8px 0 rgba(54, 60, 76, 0.08),
              0 3px 4px 0 rgba(0, 0, 0, 0.04);
  border: solid 1px ${props => props.theme.colorGrayLight};
  position:relative;
  margin-top: 8px;

  > div {
    margin: 8px 0;
  }

  ${props => colorStyles[props.$style]}
`;

export default StyledNotifications;
